import { Theme } from '@nexelem/deprecated-theme';

export const getInputStateDefaultStyles = (theme: Theme) => {
  const typedTheme = theme as Theme;
  const {
    spacing,
    palette: { getColor },
  } = typedTheme;
  const { defaultColors } = typedTheme.client.inputs;

  return {
    transition: 'all 250ms ease',
    border: `${spacing(0.25)} solid ${getColor(defaultColors.defaultState.borderColor)}`,
    outline: `${spacing(0.25)} solid transparent`,
    borderRadius: spacing(1),
    '::placeholder': {
      color: getColor(defaultColors.defaultState.placeholderColor),
      opacity: '1',
      fontStyle: 'italic',
    },
    ':hover': {
      borderColor: getColor(defaultColors.hover),
      borderWidth: spacing(0.25),
    },
    ':active': {
      borderColor: getColor(defaultColors.active),
      borderWidth: spacing(0.5),
    },
    ':focus': {
      borderColor: getColor(defaultColors.focus),
      borderWidth: spacing(0.25),
      outline: `${spacing(0.25)} ${getColor(defaultColors.focus)} solid`,
    },
  };
};
